'use client'
import { createContext, useMemo } from 'react'
import type { FC, ReactNode } from 'react'
import type { TypeDictionary } from '@/app/dictionaries'

type Dictionary = TypeDictionary

export const TranslationsContext = createContext<{ dictionary: Dictionary }>({ dictionary: {} as Dictionary })

type Props = {
  children: ReactNode
  dictionary: Dictionary
}

export const TranslationsProvider: FC<Props> = ({ children, dictionary }) => {
  const contextValue = useMemo(() => ({ dictionary }), [dictionary])
  return (
    <TranslationsContext.Provider value={contextValue}>
      {children}
    </TranslationsContext.Provider>
  )
}
